import CompositionsServices from './services/compositions.services';

const moduleName = 'app.massia.common.compositions';

angular.module(moduleName, []).service('CompositionsServices', CompositionsServices);

export default moduleName;
